import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img from "../../../images/podcast/ep-1.png";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Banner({data}) {
    return (

        <div className="services_banner ">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="example" data-text="Tek Podcast">
                            <h1>Managing Partner of Tekrevol Daniel Burgess</h1>
                        </div>
                        <div
                            className="banner_content_txt listing_flex">
                            <p>In episode 1 of Technology For Change, Tekrevol's Managing Partner Daniel Burgess is joined by Lillian Row, a Baltimore County Board of Education member. The Podcast features a brief discussion on the world of technology and how it is changing lives to better educational organizations. Lillian Row explains the importance of technology within educational institutes, how viable the idea is, and how it affects students' and teachers' lives.</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto text-center">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;